import { invalid, Moment, unitOfTime } from 'moment';
import { PlanData, CorpTaxDatesDto } from "sharedFeatures/sharedModels";
import { ItemData } from "sharedFeatures/form";

import * as moment from 'moment/moment';

export interface startDateData
{ 
    months: Array<ItemData>;
    years: Array<ItemData>;
    forecastYears: Array<ItemData>;
    
};

export class DateUtils {

    januaryMonthText = $localize`January`;
    februaryMonthText = $localize`February`;
    marchMonthText = $localize`March`;
    aprilMonthText = $localize`April`;
    mayMonthText = $localize`May`;
    juneMonthText = $localize`June`;
    julyMonthText = $localize`July`;
    augustMonthText = $localize`August`;
    septemberMonthText = $localize`September`;
    octoberMonthText = $localize`October`;
    novemberMonthText = $localize`November`;
    decemberMonthText = $localize`December`;
    static yearText = $localize`Year`;
    static yearsText = $localize`Years`;
    static fromPartialFinancialYearText = $localize`from partial financial year`;

    public monthsComboItems: Array<ItemData> = [
        { id: 0, value: this.januaryMonthText, disabled: false },
        { id: 1, value: this.februaryMonthText, disabled: false },
        { id: 2, value: this.marchMonthText, disabled: false },
        { id: 3, value: this.aprilMonthText, disabled: false },
        { id: 4, value: this.mayMonthText, disabled: false },
        { id: 5, value: this.juneMonthText, disabled: false },
        { id: 6, value: this.julyMonthText, disabled: false },
        { id: 7, value: this.augustMonthText, disabled: false },
        { id: 8, value: this.septemberMonthText, disabled: false },
        { id: 9, value: this.octoberMonthText, disabled: false },
        { id: 10, value: this.novemberMonthText, disabled: false },
        { id: 11, value: this.decemberMonthText, disabled: false },
    ];

    public static getMonthCountBetween(startDate: moment.Moment, endDate: moment.Moment): number {

        let count = 0;

        let date = startDate.clone();
        for (; this.getStartOffDate(date, 'month') <= this.getStartOffDate(endDate, 'month'); date.add(1, 'months'))
            count++;

        return count;
    }

    public static getStartOffDate(date: Moment, units: string): Moment {

        if (!date) return invalid();

        let d: Moment = date.clone();

        d.startOf(units as unitOfTime.StartOf);

        return d;
    }

    public static toMonthYearDate(date: Moment): Moment {

        if (!date) return invalid();

        var d = date.clone();

        d.startOf('day');

        return d;
    }

    public static addMonths(date: Moment, monthCount: number): void {

        if (!date) return;

        if (date.date() == date.clone().endOf('month').date())
            date.add(monthCount, 'months').endOf('month');
        else date.add(monthCount, 'months');
    }

    public static getMinDate(array: Array<Moment>): Moment {

        if (array.length == 0) return invalid();
        let min = invalid();
        array.forEach(function (date: Moment) { if (date) min = date; });

        for (var i = 0; i < array.length; i++)
            if (array[i] && min.isAfter(array[i])) min = array[i];

        return min;
    }

    public static getMaxDate(array: Array<Moment>): Moment {

        if (array.length == 0) return invalid();
        let max = invalid();
        array.forEach(function (date: Moment) { if (date) max = date; });

        for (var i = 0; i < array.length; i++)
            if (array[i] && max.isBefore(array[i])) max = array[i];

        return max;
    }

    public static isBetweenDates(date: Moment, dateStart: Moment, dateEnd: Moment) {

        if (date.isBetween(dateStart, dateEnd) || date.isSame(dateStart) || date.isSame(dateEnd)) return true;

        return false;
    }

    private static getMonth(monthIdx: number): string {
        var comboItems = new DateUtils().monthsComboItems;
        return comboItems.find(x => x.id === monthIdx - 1)?.value ?? comboItems[0].value;
    }

    public static fillCorpTaxDates(
        corpTaxDataExisting: boolean,
        corpTaxExistingTaxPrior: number,
        monthOffset: number,
        paidInMonth: number,
        planData: PlanData): CorpTaxDatesDto
    {
        let result: CorpTaxDatesDto = new CorpTaxDatesDto();
        result.existingTaxPrior = corpTaxExistingTaxPrior;

        let FYE = planData.planYearEnd; // financial year end month
        let FYS = planData.planYearEnd + 1; // financial year start month
        if (FYS > 12)
            FYS = 1;

        let firstPlanYear = moment(planData.planStartDate).toDate().getFullYear();
        let firstPlanYearMinusMonth = moment(planData.planStartDate).subtract(1, 'months').toDate().getFullYear();


        let planEndMonth = moment(planData.planEndDate).toDate().getMonth() + 1;
        let planStartMonth = moment(planData.planStartDate).toDate().getMonth() + 1;
        let planBeforeStartMonth = planStartMonth - 1;
        if (planBeforeStartMonth == 0)
            planBeforeStartMonth = 12;


        result.showExisting = corpTaxDataExisting;

        // The year the financial year ends in is whatever year it is when the first FYE month(say, February) happens in the plan. So it could be plan start year, or it could be plan start year + 1
        let FFYeY = firstPlanYear;
        if (planStartMonth > FYE)
            FFYeY = firstPlanYear + 1;

        let FFYeDate = moment().year(FFYeY).month(FYE).date(1);
        let FFYsDate = FFYeDate.subtract(11, 'months');
        // financial year starting year = the year that the financial year ends in, minus 11 months
        let FFYsY = FFYsDate.toDate().getFullYear();

        // show or hide existing input fields

        // calc existing prior visibility
        // Show this if FYE month + offset is 13 or more months from the start month of the plan.
        // (We look for the difference in months between the plan start month and the next occurring FYE month in the plan.)
        // Exception: If financial year end matches plan end month, do not show this input.

        // Number of months the first FYE month in the plan is after Plan Start
        let numberFYE;

        numberFYE = moment().year(FFYeY).month(FYE).date(1).diff(moment(planData.planStartDate), 'months') - 1;


        if (numberFYE + monthOffset >= 13) {

            if (FYE != planEndMonth) {
                // show existing previous
                result.showExistingPrior = true;
                // Tax owed for the financial year[[financial year start month][year before first financial year starting year]]to[[financial year end month][year before first financial year ending year]][enter AMOUNT] to be paid in [Paid in month][first plan year].

                result.priorFROM = "{0} {1}".format(this.getMonth(FYS), FFYsY - 1);
                result.priorTO = "{0} {1}".format(this.getMonth(FYE), FFYeY - 1);

                // Paid in year calc rules:
                // EXISTING PRIOR
                // 'Plan start month + Number of months the first FYE month in the plan is after Plan Start + offset -1 year'
                let priorPaidInYear = moment(planData.planStartDate)
                    .add(numberFYE + monthOffset, 'months')
                    .subtract(1, 'years')
                    .toDate().getFullYear();

                result.priorPaidIn = "{0} {1}".format(this.getMonth(paidInMonth), priorPaidInYear);
            }
        }

        // EXISTING Paid in year calc rules:
        if (result.showExistingPrior) {
            // EXISTING if EXISTING PRIOR is present:
        }
        else {
            // EXISTING on it's own:
            result.existingTaxPrior = 0;
        }

        // calc existing visibility
        if (FYE == planEndMonth) {

            //If the plan’s FYE month matches the plan’s end month, display:

            //[[Paid in month][Plan start month + offset]]payment:
            //[enter AMOUNT]
            //from financial year[[financial year start month][plan start year - 1]]
            //to[[financial year end month][plan start year - 1]]
            let paidInYear = moment(planData.planStartDate)
                .add(monthOffset, 'months')
                .toDate().getFullYear();

            result.taxOwedText = "from financial year";
            result.FROM = "{0} {1}".format(this.getMonth(FYS), firstPlanYear - 1);
            result.TO = "{0} {1}".format(this.getMonth(FYE), firstPlanYearMinusMonth);

            // BR-9189 paid in year issue correction
            if (paidInYear > firstPlanYearMinusMonth && FYE < paidInMonth)
                paidInYear = firstPlanYearMinusMonth;

            result.existingPaidIn = "{0} {1}".format(this.getMonth(paidInMonth), paidInYear);
        }
        else {

            // If the plan's FYE month does NOT match the plan's end month, change the initial text to:

            //[[Paid in month][Plan start month + Number of months the first FYE month in the plan is after Plan Start + offset]]payment:
            //[enter AMOUNT]
            //from partial financial year[[financial year start month][first financial year starting year,]]
            //to[[financial year end month][year of plan start - 1 month]]
            let paidInYear = moment(planData.planStartDate)
                .add(numberFYE + monthOffset, 'months')
                .toDate().getFullYear();

            result.taxOwedText = this.fromPartialFinancialYearText;
            result.FROM = "{0} {1}".format(this.getMonth(FYS), FFYsY);
            result.TO = "{0} {1}".format(this.getMonth(planBeforeStartMonth), firstPlanYearMinusMonth);

            result.existingPaidIn = "{0} {1}".format(this.getMonth(paidInMonth), paidInYear);
        }
        return result;
    }

    public static getStartDateParam(startDate: Date): string { 
        let day = startDate.getDate();       // yields date
        let month = startDate.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
        let year = startDate.getFullYear();  // yields year
        let hour = startDate.getHours();     // yields hours
        let minute = startDate.getMinutes(); // yields minutes
        let second = startDate.getSeconds(); // yields seconds

        // After this construct a string with the above results as below
        return day + "/" + month + "/" + year + " " + hour + ':' + minute + ':' + second;
    }

    public static FillActualsMonthArray(
        forecastStartMonth: number,
        forecastStartYear: number,
        actualsStartYear: number,
        currentLength: number,
        maxLength: number
    )
    { 
        let actualsStartingMonths = <Array<ItemData>>[];
        //let lengthOverhead = forecastStartYear - actualsStartYear + currentLength > maxLength + 1;
        let lengthOverhead = forecastStartYear != actualsStartYear;

        let months = new DateUtils().monthsComboItems;
        months.forEach((item: ItemData) => {
            let skipItem = false;

            if (actualsStartYear == forecastStartYear)
                skipItem = item.id > forecastStartMonth;           
            else if (lengthOverhead)
                skipItem = item.id < forecastStartMonth;           
            
            item.disabled = skipItem;
            actualsStartingMonths.push(item);
        });

        return actualsStartingMonths;
    }

    public static ReEvaluateActualsStartDate(
        forecastStartMonth: number,
        forecastStartYear: number,
        actualsStartYear: number,
        currentLength: number,
        maxLength: number): startDateData
    { 
        maxLength = maxLength / 12;
        let comboMaxYears = 14;
        if (comboMaxYears < maxLength)
            comboMaxYears = maxLength;
        
        let actualsStartingYears = <Array<ItemData>>[];         

        // The earliest allowed actuals start date can be calculate as follows:
        // forecast start date - 1 year
        let actualYearliestYear = forecastStartYear - 1;
       

        // fill actuals start date years array
        for (let i = 0; i < comboMaxYears; i++) {         
            if (actualYearliestYear + i <= forecastStartYear)
                actualsStartingYears.push({ id: i, value: (actualYearliestYear + i).toString(), disabled: false });
        }

        // fill actuals start date months array
        let actualsStartingMonths = DateUtils.FillActualsMonthArray(
            forecastStartMonth,
            forecastStartYear,
            actualsStartYear,
            currentLength,
            maxLength);

        return {
            'months': actualsStartingMonths,
            'years': actualsStartingYears,
            forecastYears: []
        };
    }

    public static ReEvaluateForecastStartDate(
        actualsStartMonth: number,
        actualsStartYear: number,        
        forecastStartYear: number,
        maxLength: number): startDateData {
        
        const comboMaxYears = 14;

        let forecastStartingYears = <Array<ItemData>>[];
        let forecastStartingMonths = <Array<ItemData>>[];
        let forecastYears = <Array<ItemData>>[];
        maxLength = maxLength / 12;

        let actualsStartDate = new Date(actualsStartYear, actualsStartMonth, 1, 12);
        
        // Forecast start date min/max = Actuals start date / Actuals start date + max plan length - 1 year

        const currentYear = new Date().getFullYear();
        if (forecastStartYear < currentYear)
            forecastStartYear = currentYear;
        
        // fill forecast start date years array
        for (let i = -3; i < comboMaxYears; i++) {
            let curYear = currentYear + i;
            if (curYear <= currentYear + maxLength)
                forecastStartingYears.push({ id: i, value: curYear.toString(), disabled: false });
        }

        // fill actuals start date months array
        let months = new DateUtils().monthsComboItems;
        months.forEach((item: ItemData) => {           
            //item.disabled = item.id < actualsStartMonth;
            forecastStartingMonths.push(item);
        });

        // Forecast length min  = 1 year 
        forecastYears.push({ id: 1, value: `1 ${this.yearText}`, disabled: false });
        // Forecast length max = max plan length - (forecast start date - actuals start date)
        for (let i = 1; i <= maxLength - (forecastStartYear - actualsStartYear); i++)
            forecastYears.push({ id: i + 1, value: `${i + 1} ${this.yearsText}`, disabled: false });

        return {
            'months': forecastStartingMonths,
            'years': forecastStartingYears,
            forecastYears: forecastYears
        };

    }

    public static getDateDelta(startDate: moment.Moment, newVal: number, deltaType: string): number {
        // get start date delta in months
        let result = 0;
        let newPlanStartDate = undefined;
        let oldPlanStartDate = startDate.clone();

        if (deltaType == 'months')
            newPlanStartDate = startDate.month(newVal);
        else
            newPlanStartDate = startDate.year(newVal);

        //let oldPlanStartDate = this.planData.planStartDate;        
        result = newPlanStartDate.diff(oldPlanStartDate, 'month');
        console.log('month delta:' + result);
        return result;
    }

}
